export default {
	bizInspectStatisticsReport: {
		title: '统计报表',
		dateRange: {
			startDate: '开始日期',
			endDate: '结束日期',
			separator: '至'
		},
		query: '查询',
		export: '导出',
		loading: '数据更新中，请稍候...',
		updateSuccess: '数据更新完成',
		charts: {
			deviceRun: '设备运行情况',
			deviceWarn: '总体报警情况',
			deviceHealth: '总体监测情况',
			warnType: '故障类型统计',
			deviceType: '厂区设备故障统计',
			warnTrend: '设备告警趋势',
			warnList: '测点告警',
			reportList: '故障案例',
			mtbfStatistics: '设备平均故障间隔时间统计'
		},
		deviceRun: {
			total: '总数',
			running: '运行',
			online: '在线',
			stopped: '停机',
			offline: '离线'
		},
		deviceWarn: {
			severe: '严重',
			medium: '中等',
			general: '一般',
			normal: '正常'
		},
		warnTrend: {
			generalAlarm: '一般告警',
			mediumAlarm: '中等告警',
			severeAlarm: '严重告警'
		},
		warnList: {
			index: '序号',
			deviceName: '告警设备',
			pointName: '告警测点',
			reason: '告警原因',
			level: '告警等级',
			time: '告警时间',
			general: '一般',
			medium: '中等',
			severe: '严重',
			normal: '正常'
		},
		reportList: {
			index: '序号',
			attachment: '案例附件',
			type: '案例类型',
			author: '编制人',
			time: '出具时间',
			healthReport: '体检报告',
			diagnosisReport: '诊断报告'
		},
		mtbfStatistics: {
			index: '序号',
			deviceName: '设备名称',
			faultCount: '故障次数',
			avgInterval: '平均间隔 (h)',
			lastFault: '最近故障'
		},
		deviceTypeChart: {
			title: '设备台账总览',
			total: '总数',
			unit: '台'
		},
		warnTypeChart: {
			title: '故障类型统计',
			total: '总数',
			unit: '条'
		}
	}
}
